import React from "react";
import { Select } from "antd";

const { Option } = Select;

const WrappedSelect = ({
  options,
  onChange,
  disabled = false,
  loading = false,
  value,
  defaultValue,
  width = "328px",
}) => {
  const handleChange = (value) => {
    console.log("Selected Value: ", value);
    if (onChange) {
      onChange(value);
    }
  };

  const opt = Object.entries(options).map(([key, value]) => (
    <Option key={key} value={key}>
      {value.text}
    </Option>
  ));

  return (
    <Select
      onChange={handleChange}
      disabled={disabled}
      loading={loading}
      allowClear
      style={{ width }}
      value={value}
      defaultValue={defaultValue}
    >
      {opt}
    </Select>
  );
};

export default WrappedSelect;
